/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Component imports
import { Checkbox, Divider, Form, Input, Space, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import ThumbsFeedbackFormItems from '../../../Forms/ThumbsFeedbackFormItems';
import ArticlePreviewButton from '../../../UI/ArticlePreviewButton';

// Misc imports
import { useBotLanguage } from '../../../../utils/hooks/useBotLanguage';

// Constant declarations
const { Text } = Typography;

const KnowledgeBaseArticleAAForm = ({
  form,
  responseIndex,
  canEdit,
  articleId,
  knowledgeBaseId
}) => {
  const { t } = useTranslation();
  const { botLanguages } = useBotLanguage();

  return (
    <Fragment>
      <Space className="mb-3 mt-1">
        <InfoCircleOutlined className="text-secondary" />
        <Text className="text-secondary">{t('Agent will reply with the Article body which you can preview here:')}</Text>
      </Space>

      <ArticlePreviewButton
        className="bg-skeleton mb-3"
        articleId={articleId}
        knowledgeBaseId={knowledgeBaseId}
        buttonText={t('Preview Article Body')}
        block
      />

      {
        botLanguages.map(lang => (
          <Form.Item
            key={`${responseIndex}__${lang}`}
            name={[responseIndex, 'options', 0, lang]}
            hidden
          >
            <Input />
          </Form.Item>
        ))
      }

      <Form.Item
        name={[responseIndex, 'useGeneratedResponse']}
        valuePropName="checked"
        className="mb-0"
      >
        <Checkbox
          disabled={!canEdit}
        >
          {t('Use AI generated text instead of the whole article body')}
        </Checkbox>
      </Form.Item>

      <Divider className="mt-4 mb-2" />

      <ThumbsFeedbackFormItems
        responseIndex={responseIndex}
        form={form}
        canEdit={canEdit}
      />
    </Fragment>
  );
};

KnowledgeBaseArticleAAForm.propTypes = {
  form: PropTypes.object.isRequired,
  responseIndex: PropTypes.string.isRequired,
  canEdit: PropTypes.bool.isRequired,
  articleId: PropTypes.string.isRequired,
  knowledgeBaseId: PropTypes.string.isRequired
};

export default KnowledgeBaseArticleAAForm;
